import Store from '@/main/store';
import { IInteractEventTrackerState } from './state';

import { IInteractEventTrackerAction } from '../entities/IInteractEventTracker';

import { sendEventIntegration } from '@/api/resources/events';

import { TInteractEventTrackerActionAction } from '../types/TInteractEventTracker';

let eventQueue: { action: TInteractEventTrackerActionAction, handler: any }[] = [];
let eventQueueCurrentProcessing: string | null = '';

export default {
  sendInteractEvent(state: IInteractEventTrackerState, interactEventAction: IInteractEventTrackerAction): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const oldQueue = Object.assign({}, eventQueue);

        if (!eventQueue.some((event) => event.action === interactEventAction.action)) {
          state.interactEventTracker.addAction
            && state.interactEventTracker.addAction(interactEventAction);

          eventQueue.push({
            action: interactEventAction.action, handler: async () => {
              await sendEventIntegration({
                ...state.interactEventTracker,
                actions: [{
                  ...interactEventAction,
                  attributes: {
                    ...interactEventAction.attributes,
                    ...state.interactEventTracker.dynamicAttributesValues,
                  }
                }]
              });

              state.interactEventTracker.removeAction
                && state.interactEventTracker.removeAction(interactEventAction.action);
            }
          });
        }

        const queueResolved = await Promise.all(
          eventQueue
            .filter(event => event.action !== eventQueueCurrentProcessing)
            .map(async (interaction) => {
              return new Promise(async (resolve, reject) => {
                eventQueueCurrentProcessing = interaction.action;

                try {
                  await new Promise(resolve => {
                    const loadingChecker = setInterval(() => {
                      if (Store.getters['App/Checkout/selectedOffer'].id) {
                        clearInterval(loadingChecker);
                        resolve(true);
                      }
                    }, 500);
                  });

                  await interaction.handler();

                  eventQueue = eventQueue.filter((interactionF) => {
                    return interactionF.action !== interaction.action;
                  });

                  resolve(interaction.action);
                } catch (error) {
                  reject(error);
                }
              });
            })
        );

        resolve(interactEventAction.action);
      } catch (error) {
        reject(error);
      } finally {
        state.loading = false;
      }
    });
  },
};
